import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import usePageTracking from './hooks/useAnalytics';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AdminLayout from './components/admin/AdminLayout';

// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import Sectors from './pages/Sectors';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import Methodology from './pages/Methodology';
import Contact from './pages/Contact';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminJobs from './pages/admin/AdminJobs';
import AdminBlogs from './pages/admin/AdminBlogs';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminResumes from './pages/admin/AdminResumes';
import AdminContacts from './pages/admin/AdminContacts';
import ChangePassword from './pages/admin/ChangePassword';
import ForgotPassword from './pages/admin/ForgotPassword';
import ResetPassword from './pages/admin/ResetPassword';
import AdminSubscribers from './pages/admin/AdminSubscribers';

// Public Layout Wrapper
const PublicLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};

// Analytics wrapper component
const AnalyticsWrapper = ({ children }) => {
  usePageTracking();
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AnalyticsWrapper>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/sectors" element={<PublicLayout><Sectors /></PublicLayout>} />
          <Route path="/jobs" element={<PublicLayout><Jobs /></PublicLayout>} />
          <Route path="/jobs/:id" element={<PublicLayout><JobDetail /></PublicLayout>} />
          <Route path="/blogs" element={<PublicLayout><Blogs /></PublicLayout>} />
          <Route path="/blogs/:slug" element={<PublicLayout><BlogDetail /></PublicLayout>} />
          <Route path="/methodology" element={<PublicLayout><Methodology /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="resumes" element={<AdminResumes />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="subscribers" element={<AdminSubscribers />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnalyticsWrapper>
    </BrowserRouter>
  );
}

export default App;
